import { SETTINGS, SUPPORT } from "routes/pageConfig";

// ORDER MATTERS!
// eslint-disable-next-line import/prefer-default-export
export const HEADER_DROPDOWN_ITEMS = [
  SUPPORT,
  SETTINGS,
];